/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function PriceRange(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1024 16.5049C15.6065 16.5562 15.9998 16.9823 15.9998 17.5C15.9998 18.0177 15.6065 18.4438 15.1024 18.4951L14.9998 18.5H4.99984C4.44767 18.4999 3.99984 18.0522 3.99984 17.5C3.99984 16.9478 4.44767 16.5001 4.99984 16.5H14.9998L15.1024 16.5049ZM10.0008 5.66699C10.3205 5.66723 10.6214 5.82056 10.8094 6.0791L13.745 10.1162L16.4246 9.44727C16.7832 9.35774 17.1625 9.4726 17.41 9.74707C17.6573 10.0218 17.7336 10.4114 17.6073 10.7588L15.9403 15.3418C15.7966 15.7367 15.421 15.9997 15.0008 16H5.00082C4.58046 16 4.20421 15.7368 4.06039 15.3418L2.39437 10.7588C2.26799 10.4112 2.34307 10.0218 2.59066 9.74707C2.8382 9.47249 3.21734 9.35769 3.57601 9.44727L6.25472 10.1162L9.19222 6.0791L9.26742 5.9873C9.45541 5.78453 9.72077 5.66699 10.0008 5.66699ZM7.47543 11.8389C7.23568 12.1681 6.81982 12.3193 6.42465 12.2207L4.91586 11.8428L5.70101 14H14.2996L15.0838 11.8428L13.576 12.2207C13.1809 12.3193 12.765 12.168 12.5252 11.8389L9.99984 8.36621L7.47543 11.8389ZM9.99984 1.66699C10.9202 1.66699 11.6667 2.41268 11.6668 3.33301C11.6668 4.25348 10.9203 5 9.99984 5C9.07948 4.99987 8.33383 4.2534 8.33383 3.33301C8.334 2.41276 9.07959 1.66712 9.99984 1.66699Z"
        fill="#35424F"
      />
    </svg>
  )
}

PriceRange.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default PriceRange
